import ReactGA from 'react-ga4';
const TrackingUtils = {

    TrackPageView : (data) =>{
        
        ReactGA.send({
          ...data
        });
      },
    TrackUserEvent : (data) =>{
    ReactGA.event({
        ...data
    });
    },
}
export default TrackingUtils;